import { useEffect } from 'react';

import { PaginatedTable } from '@/components/PaginatedTable';
import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useLatestIssues } from '@/hooks/discovery/latestIssues';
import { useLatestIssuesColumns } from '../hooks/useLatestIssuesColumns';

const PAGE_SIZE = 5;

type LatestIssuesProps = {
  /** Used for stubbing `new Date()` in testing */
  now?: Date;
  setLastRunAt: (lastRunAt: string | null) => void;
  setLastChangedAt: (lastChangedAt: string | null) => void;
};

export const LatestIssues = ({
  setLastRunAt,
  setLastChangedAt,
  // ...props
}: LatestIssuesProps) => {
  const { environmentId } = useDbtCloudProject();

  const latestIssues = useLatestIssues({
    pageSize: PAGE_SIZE,
    environmentId,
  });

  // const columns = useLatestIssuesColumns(props);
  const columns = useLatestIssuesColumns();
  const changedAt = null;
  const runAt = latestIssues.lastUpdatedAt || null;
  const isLoading = latestIssues.fetching;
  useEffect(() => {
    if (!isLoading) {
      setLastChangedAt(changedAt);
      setLastRunAt(runAt);
    }
  }, [changedAt, runAt, isLoading, setLastChangedAt, setLastRunAt]);

  return (
    <div>
      <PaginatedTable
        data={latestIssues.data ?? []}
        isLoading={latestIssues.fetching}
        maxResultCount={undefined}
        pageSize={PAGE_SIZE}
        pagination={{
          hasMorePages: latestIssues.pageInfo?.hasNextPage,
          isPageLoading: latestIssues.fetching,
          onLoadMore: latestIssues.fetchMore,
        }}
        emptyStateProps={{
          header: `There are no issues in this project`,
        }}
        columns={columns}
      />
    </div>
  );
};
